module.exports = __webpack_public_path__ + "static/media/strike_defender.715d9f1d.md";